<template>
  <div class="hp-base-panel-wrp">
    <div class="cert-panel hp-base-panel">
      <template v-if="expertise.length">
        <div class="hp-title">
          <em class="left">擅长领域</em>
        </div>
        <ul class="expert-list">
          <li class="expert-item" v-for="(e, index) in expertise" :key="index">
            <div class="expert-name">
              <p class="expert-name-hide">{{ e.category }}</p>
              <p class="expert-name-show">{{ e.category }}</p>
            </div>
            <div class="tabs-wrap">
              <!-- <template v-for="tag in e.tags"> -->
              <span class="expert-tags">{{ filterTags(e.tags) }}</span>
              <!-- </template> -->
            </div>
          </li>
        </ul>
      </template>

      <template v-if="therapyFeature.length">
        <div class="hp-title">
          <em class="left">擅长疗法</em>
        </div>
        <div class="tabs-wrap">
          <template v-for="t in therapyFeature">
            <span class="expert-label" :key="t">{{ t }}</span>
          </template>
        </div>
      </template>

      <template v-if="serviceGroups.length">
        <div class="hp-title">
          <em class="left">咨询人群</em>
        </div>
        <div class="tabs-wrap">
          <template v-for="s in serviceGroups">
            <span class="expert-label" :key="s">{{ s }}</span>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    consultServiceInfo() {
      return this.$store.getters['homepage/consultServiceInfo']
    },
    therapyFeature() {
      const { therapy_feature = [] } = this.consultServiceInfo
      return therapy_feature.length
        ? therapy_feature.join('，').split('，')
        : []
    },
    serviceGroups() {
      const { service_groups = [] } = this.consultServiceInfo
      return service_groups.length ? service_groups.join('，').split('，') : []
    },
    expertise() {
      return this.consultServiceInfo.expertise || []
    }
  },
  methods: {
    filterTags(e) {
      if (!e || !e.length) return ''
      return e.join('、')
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-title {
  padding-bottom: 26px !important;
  padding-top: 50px;
  &:nth-of-type(1) {
    padding-top: 0;
  }
}
.cert-panel {
  .normal-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 38px;
  }
  .expert-list {
    .expert-item {
      width: 100%;
      // height: 180px;
      // background: #ffffff;
      // box-shadow: 0px 0px 40px 0px #ebefff;
      // border-radius: 10px;
      background: #f8f9ff;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px 22px;
      box-sizing: border-box;
      overflow: hidden; // 清除浮动
      &:last-child {
        margin-bottom: 0;
      }

      // @mixin _a {
      //   content: '';
      //   width: 108px;
      //   height: 15px;
      //   border-radius: 8px;
      //   filter: blur(5px);
      //   position: absolute;
      //   left: 50%;
      //   transform: translate(-50%, 0);
      //   bottom: 0;
      //   z-index: 1;
      // }

      // &:nth-child(1) .expert-name:after {
      //   @include _a;
      //   background: #fff3ed;
      // }
      // &:nth-child(2) .expert-name:after {
      //   @include _a;
      //   background: #edfff5;
      // }
      // &:nth-child(3) .expert-name:after {
      //   @include _a;
      //   background: #edefff;
      // }
    }
    .expert-name {
      font-size: 28px;
      line-height: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #6982fa;
      margin-bottom: 16px;
      position: relative;
      float: left;
      .expert-name-hide {
        opacity: 0;
      }
      .expert-name-show {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 2;
      }
    }
  }
  .tabs-wrap {
    clear: both; // 清除浮动
    padding: 0;
    box-shadow: none;
    .expert-label {
      display: inline-block;
      margin: 0 15px 15px 0;
      padding: 0 30px;
      height: 52px;
      background: #f8f9ff;
      border-radius: 26px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #434c5c;
      line-height: 52px;
    }
    .expert-tags {
      font-size: 26px;
      color: #6c798c;
      line-height: 39px;
    }
  }
}
</style>
